import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import FaqAccordion from "@/components/base/FaqAccordion";
import { faqList } from "@/mocks/faq";
import { usePageMeta } from "@/hooks/usePageMeta";

const quickLinks = [
  { to: "/method", label: "真假辨析方法", desc: "证据如何分级、分数怎么算" },
  { to: "/topics", label: "爆料追踪列表", desc: "按分类与关键词查找事件" },
  { to: "/about", label: "投稿与更正", desc: "提交线索或反馈信息偏差" },
];

export default function FaqPage() {
  usePageMeta({
    title: "常见问题 - 评分口径与依据分级说明 | 蝌蚪爆料",
    description:
      "解答关于蝌蚪爆料的常见疑问：可信度评分如何计算、事件为何长期处于追证中、截图对比能证明什么，以及如何提交更正与反馈。",
    keywords: "蝌蚪爆料常见问题,可信度评分说明,依据分级,截图对比,蝌蚪爆料可信度",
    canonicalPath: "/faq",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqList.map((item) => ({
          "@type": "Question",
          name: item.q,
          acceptedAnswer: { "@type": "Answer", text: item.a },
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: "https://jiumeijiaju.cn/" },
          { "@type": "ListItem", position: 2, name: "常见问题", item: "https://jiumeijiaju.cn/faq" },
        ],
      },
    ],
  });

  return (
    <SiteLayout>
      <header className="border-b border-background-300 bg-background-100">
        <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
          <nav aria-label="面包屑" className="flex items-center gap-2 font-label text-xs text-foreground-500">
            <Link to="/" className="hover:text-primary-700 cursor-pointer">首页</Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-foreground-800">常见问题</span>
          </nav>
          <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            常见问题
          </h1>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            关于评分口径、依据分级与更正流程的集中说明。如果没有找到答案，可以通过反馈渠道联系我们。
          </p>
        </div>
      </header>

      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <FaqAccordion items={faqList} defaultOpen={0} />
          </div>
          <aside className="lg:col-span-4">
            <div className="lg:sticky lg:top-24 space-y-6">
              <div className="rounded-lg border border-background-300 bg-background-100 p-5">
                <h2 className="font-heading text-sm font-semibold text-foreground-950">快速前往</h2>
                <ul className="mt-4 space-y-3">
                  {quickLinks.map((link) => (
                    <li key={link.to}>
                      <Link
                        to={link.to}
                        className="group block rounded-md border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 cursor-pointer"
                      >
                        <span className="flex items-center justify-between font-heading text-sm font-semibold text-foreground-900">
                          {link.label}
                          <i className="ri-arrow-right-line text-primary-600 transition-transform group-hover:translate-x-0.5" />
                        </span>
                        <span className="mt-1 block font-label text-xs text-foreground-500">{link.desc}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="rounded-lg border border-dashed border-primary-300 bg-primary-50/60 p-5">
                <h2 className="font-heading text-sm font-semibold text-foreground-950">还有疑问？</h2>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600">
                  把你遇到的问题发给我们，我们会补充到这里，方便其他读者看到。
                </p>
                <Link
                  to="/about"
                  className="mt-4 inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-primary-400 px-3 py-2 font-label text-xs text-primary-700 transition-colors hover:bg-primary-100 cursor-pointer"
                >
                  去反馈 <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </SiteLayout>
  );
}